export default [{
  name: 'home',
  path: '/',
  meta: {
    title: 'LoveMatch'
  },
  component: async () => await import('./views/home/index.js')
}, {
  name: 'event-content',
  path: '/event/:id',
  meta: {},
  component: async () => await import('./views/event-content/index.js')
}, {
  name: 'event-book',
  path: '/event/:id/book',
  meta: {},
  component: async () => await import('./views/event-book/index.js')
}, {
  name: 'line-sign-up',
  path: '/sign-up/line',
  meta: {},
  component: async () => await import('./views/line-sign-up/index.js')
}, {
  name: 'page-content',
  path: '/page/:path',
  meta: {},
  component: async () => await import('./views/page-content/index.js')
}, {
  name: 'event-flipped',
  path: '/event/:id/flipped',
  meta: { requiredAuth: true },
  component: async () => await import('./views/event-flipped/index.js')
}, {
  name: 'event-cpi-file',
  path: '/event/:id/cpi',
  meta: { requiredAuth: true },
  component: async () => await import('./views/event-cpi-file/index.js')
}, {
  name: 'event-flipped-file',
  path: '/event/:id/cpi/:to',
  meta: { requiredAuth: true },
  component: async () => await import('./views/event-flipped-file/index.js')
}, {
  name: 'match-focus-submit',
  path: '/event/:id/match-focus/submit',
  meta: {
    requiredAuth: true
  },
  component: async () => await import('./views/match-focus-submit/index.js')
}, {
  name: 'match-focus-report',
  path: '/event/:id/match-focus/report',
  meta: {
    requiredAuth: true
  },
  component: async () => await import('./views/match-focus-report/index.js')
}, {
  name: 'point',
  path: '/point',
  meta: {
    requiredAuth: true
  },
  component: async () => await import('./views/point/index.js')
}, {
  name: 'point-record',
  path: '/point/record',
  meta: {
    requiredAuth: true
  },
  component: async () => await import('./views/point-record/index.js')
}, {
  name: 'point-give',
  path: '/p/:key',
  meta: {},
  component: async () => await import('./views/point-give/index.js')
}, {
  name: 'gift',
  path: '/gift/:code',
  meta: {},
  component: async () => await import('./views/gift/index.js')
}, {
  name: 'personal-base-edit',
  path: '/personal/base',
  meta: {
    requiredAuth: true
  },
  component: async () => await import('./views/personal-base-edit/index.js')
}, {
  name: 'my-event',
  path: '/my/event',
  meta: {
    title: '我的活動',
    requiredAuth: true
  },
  component: async () => await import('./views/my-event/index.js')
}, {
  name: 'profile',
  path: '/profile',
  meta: {
    title: '個人檔案',
    requiredAuth: true
  },
  component: async () => await import('./views/profile/index.js')
}, {
  name: 'questionnaire',
  path: '/q/:id',
  meta: {},
  component: async () => await import('./views/questionnaire/index.js')
}, {
  name: 'questionnaire-result',
  path: '/q/:id/result',
  meta: {},
  component: async () => await import('./views/questionnaire-result/index.js')
}, {
  name: 'star-puzzle',
  path: '/event/:eventSid/star-puzzle',
  meta: {
    title: '眾星巧拼',
    requiredAuth: true
  },
  component: async () => await import('./views/event-star-puzzle/index.js')
}, {
  name: 'questionnaire-puzzle',
  path: '/questionnaire/:id/puzzle',
  meta: {
    title: '',
    requiredAuth: true
  },
  component: async () => await import('./views/questionnaire-puzzle/index.js')
}, {
  name: 'donate-once',
  path: '/donate/:amount',
  meta: { },
  component: async () => await import('./views/donate-redirect/index.js')
}, {
  name: 'donate-period',
  path: '/donate/:amount/:times',
  meta: { },
  component: async () => await import('./views/donate-redirect/index.js')
}, {
  name: 'donate-thank',
  path: '/donate-thank',
  meta: { },
  component: async () => await import('./views/donate-thank/index.js')
// }, {
//   name: 'fate-my-door',
//   path: '/fate-with-you/my-door',
//   component: () => import('./views/fate-with-you/my-door/index.js')
// }, {
//   name: 'fate-behold-doors',
//   path: '/fate-with-you/behold-the-doors',
//   component: () => import('./views/fate-with-you/behold-the-doors/index.js')
// }, {
//   name: 'fate-the-door',
//   path: '/fate-with-you/doors/:ticketId',
//   component: () => import('./views/fate-with-you/the-door/index.js')
// }, {
//   name: 'template',
//   path: '/template',
//   component: () => import('./views/template/index.js')
}]
